export const INSTALLERS_FORM_CONFIG = ({ formState, onChange, combos, intl, isEdit = false }) => ({
  RAZON_SOCIAL: {
    required: true,
    value: formState['nombre'] || formState['razon_social'] || '',
    name: 'nombre',
    title: 'Razón social',
    placeholder: 'Ej. Sociedad Anónima cerrada (S.A.C)',
    onChange,
  },
  CIF: {
    required: true,
    value: formState['cif'] || '',
    name: 'cif',
    title: 'NIF/NIE/CIF',
    placeholder: 'Ej: B12345678',
    onChange,
  },
  EMAIL: {
    required: true,
    inputProps: { type: 'email' },
    value: formState['email'] || '',
    name: 'email',
    title: 'Email de contacto',
    placeholder: 'Ej: empresa@dominio.com',
    onChange,
  },
  TELEFONO: {
    required: true,
    inputProps: { type: 'tel', pattern: '[6789]{1}[0-9]{8}', maxLength: 9 },
    value: formState['telefono'] || '',
    name: 'telefono',
    title: 'Teléfono',
    placeholder: 'Ej: 600000000',
    onChange,
  },
  WEB: {
    value: formState['web'] || '',
    name: 'web',
    title: 'Página web (opcional)',
    placeholder: 'Ej. tuweb.com',
    onChange,
  },
  CALLE: {
    required: true,
    value: formState['calle'] || '',
    name: 'calle',
    title: 'Calle',
    onChange,
  },
  NUMERO: {
    required: true,
    value: formState['numero'] || '',
    name: 'numero',
    title: 'Número',
    onChange,
  },
  PISO: {
    required: false,
    value: formState['piso'] || '',
    name: 'piso',
    title: 'Piso',
    onChange,
  },
  POLIGONO: {
    required: false,
    value: formState['poligono'] || '',
    name: 'poligono',
    title: 'Polígono',
    onChange,
  },
  POBLACION: {
    required: true,
    value: formState['poblacion'] || '',
    name: 'poblacion',
    title: 'Población',
    onChange,
  },
  COD_POSTAL: {
    required: true,
    inputProps: {
      pattern: '0[1-9][0-9]{3}|[1-4][0-9]{4}|5[0-2][0-9]{3}',
      maxLength: 5,
    },
    value: formState['cod_codigo_postal'] || '',
    name: 'cod_codigo_postal',
    title: 'Código Postal',
    placeholder: 'Ej. 01234',
    onChange,
  },
  REGISTRO_INDUSTRIAL_DOCUMENTO: {
    required: true,
    value: formState['registro_industrial_nuevo'],
    name: 'registro_industrial_nuevo',
    title: 'Documento de Registro Industrial / IRG3',
    onChange,
    fileProps: {
      accept: [
        'application/pdf',
      ],
      maxSize: 5242880, // 5MB
    },
    currentDoc: formState['registro_industrial_id']
      ? {
          id: formState['registro_industrial_id'],
          nombre: formState['codigo_registro_industrial'] || 'Registro_Industrial',
          extension: 'pdf',
        }
      : formState['registro_industrial'],
  },
  COMUNIDAD_AUTONOMA: {
    required: true,
    value: formState['empresa_ca_id'] || '',
    name: 'empresa_ca_id',
    title: 'Comunidad de actuación',
    values: combos?.user_empresas_ca || [],
    onChange,
    disabled: isEdit,
  },
})
